import React, { useState } from "react";

const ImportProductForm = ({ onImportComplete, onTransferComplete }) => {
  const [file, setFile] = useState(null);
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
    setResult(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      alert("Please select an Excel file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setImporting(true);
    setResult(null);

    try {
      const response = await fetch("/api/products/import", {
        method: "POST",
        body: formData,
      });

      const data = await response.json().catch(() => ({}));

      console.log("Import response:", data);

      if (!response.ok) {
        throw new Error(data.error || data.message || "Import failed.");
      }

      setResult(data);

      alert(
        `Import completed.\nTotal: ${data.total || 0}\nSuccess: ${
          data.successCount || 0
        }\nFailed: ${data.failedCount || 0}`
      );

      if (typeof onImportComplete === "function") {
        onImportComplete(data);
      }

      if (typeof onTransferComplete === "function") {
        onTransferComplete(data);
      }
    } catch (error) {
      console.error("Error importing products:", error);
      alert(error.message || "Error importing products.");
    } finally {
      setImporting(false);
    }
  };

  return (
    <div className="import-product-form">
      <h3>Import Products</h3>

      <p style={{ marginBottom: "12px", color: "#666" }}>
        Upload Excel with columns: model, colour, imei_number, serial_number,
        inventory_type, location, status, delivery_order_number.
      </p>

      <form onSubmit={handleSubmit}>
        <input
          type="file"
          accept=".xlsx,.xls,.csv"
          onChange={handleFileChange}
          disabled={importing}
        />

        <button type="submit" disabled={importing || !file}>
          {importing ? "Importing..." : "Upload and Import Products"}
        </button>
      </form>

      {result && (
        <div style={{ marginTop: "16px", textAlign: "left" }}>
          <h4>Import Result</h4>

          <p>Total: {result.total || 0}</p>
          <p>Success: {result.successCount || 0}</p>
          <p>Failed: {result.failedCount || 0}</p>

          {Array.isArray(result.results) && result.results.length > 0 && (
            <div
              style={{
                marginTop: "12px",
                maxHeight: "280px",
                overflowY: "auto",
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: "10px",
              }}
            >
              {result.results.map((r, index) => (
                <div
                  key={index}
                  style={{
                    padding: "8px 0",
                    borderBottom: "1px solid #eee",
                  }}
                >
                  <strong>{r.status}</strong>

                  {r.error && (
                    <div style={{ color: "red", marginTop: "4px" }}>
                      Error: {r.error}
                    </div>
                  )}

                  <div style={{ fontSize: "12px", color: "#666" }}>
                    Model: {r.row?.model || "-"} | Colour:{" "}
                    {r.row?.colour || "-"} | Serial:{" "}
                    {r.row?.serial_number || "-"} | IMEI:{" "}
                    {r.row?.imei_number || "-"} | Location:{" "}
                    {r.row?.location || "-"}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ImportProductForm;